import { maybeFetchCurrentTrackingToken } from 'core_main/api/tracking';
import { post, uploadToS3 } from 'core_main/request';
import { ATTACHMENTS_ENDPOINT } from './constants';
import { validateAttachments } from './helpers';
import { AttachmentsApiResponse, AttachmentParams } from './types';

export const uploadAttachmentToS3 = (
  attachment: AttachmentParams,
  response: AttachmentsApiResponse,
) => {
  if (!response?.meta?.upload) return Promise.reject();

  const { fields, url } = response.meta.upload;

  const formData = new FormData();

  Object.entries(fields).forEach((field) => {
    formData.append(field[0], field[1] as string);
  });

  formData.append('file', attachment.file);

  return uploadToS3(url, formData);
};

export const createAttachment = (attachment: AttachmentParams) => {
  const { file } = attachment;

  return maybeFetchCurrentTrackingToken().then(() => {
    let attachmentResponse;

    return post(ATTACHMENTS_ENDPOINT, {
      body: JSON.stringify({
        contentLength: file.size,
        contentType: file.type,
        name: file.name,
      }),
    })
      .then((response) => {
        attachmentResponse = response;
        return uploadAttachmentToS3(attachment, response);
      })
      .then(() => {
        return attachmentResponse;
      });
  });
};

export const createAttachments = (attachments: AttachmentParams[]) => {
  if (!attachments?.length) return Promise.reject();

  const invalidAttachmentsError = validateAttachments(attachments);

  if (invalidAttachmentsError) {
    return Promise.reject(invalidAttachmentsError);
  }

  const attachmentPromises = attachments.reduce(
    (acc: Promise<AttachmentsApiResponse>[], value: AttachmentParams) => {
      const createAttachmentFetch = createAttachment(value);
      const newAcc = [...acc, createAttachmentFetch];

      return newAcc;
    },
    [],
  );

  return Promise.all(attachmentPromises);
};
